import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import Trigger from 'src/js/modules/common/components/trigger';
import withSelection from 'src/js/modules/utils/with-selection';
import restoreRange from '../helpers/restore-range';
import useTextIndentControl from '../hooks/use-text-indent-control';

const { Icon } = designSystem;

function TextIndentTrigger({ elementId, getContext, triggerId, iconGlyph }) {
  const { selection, triggersState, onTriggerClick } = useTextIndentControl(elementId);
  const { controlPane } = getContext();

  const handleClick = () => {
    onTriggerClick(triggerId);

    try {
      restoreRange(selection, elementId);
    } catch (error) {
      console.error(error);
    }

    controlPane.forceHighlighterRerender();
  };

  return (
    <Trigger id={triggerId} disabled={triggersState[triggerId]} onClick={handleClick}>
      <Icon glyph={iconGlyph} size="20" />
    </Trigger>
  );
}

TextIndentTrigger.propTypes = {
  elementId: PropTypes.string.isRequired,
  getContext: PropTypes.func.isRequired,
  triggerId: PropTypes.string.isRequired,
  iconGlyph: PropTypes.string.isRequired,
};

export default withSelection(TextIndentTrigger);
